import {css} from 'lit';

import {defaultStyles} from '../../../components/message.js';

export const styles = defaultStyles.extends({
  statics: css``,
  colorGen: () => '',
});

export default {styles};
